module.exports = __webpack_public_path__ + "static/media/Settings-3.51ca8b71.svg";